import {
  ChangeDetectionStrategy,
  Component,
  input,
  model,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '../../../app/shared/pipes/translationPipe';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-search-bar',
  imports: [
    FormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatIcon,
    TranslatePipe,
    AsyncPipe,
  ],
  template: `
    <mat-form-field
      appearance="outline"
      [class.search-background]="backgroundColor()"
      class="search-bar no-subscript-wrapper bar-width"
    >
      @if (clearButton()) {
      <mat-icon matIconPrefix>search</mat-icon>
      } @else {
      <mat-icon
        matIconPrefix
        (click)="clearSearch()()"
        [class.action-icon]="prefixIcon() && query()"
        >{{ query() ? prefixIcon() : 'search' }}</mat-icon
      >

      }
      <input
        matInput
        type="text"
        [placeholder]="('search' | translate | async) ?? ''"
        [(ngModel)]="query"
        (ngModelChange)="query.set($event)"
      />
      @if (query() && clearButton()) {
      <mat-icon matSuffix (click)="clearSearch()()" class="clear-icon"
        >close</mat-icon
      >
      }
    </mat-form-field>
  `,
  styles: [
    `
      .bar-width {
        width: 100%;
      }

      .clear-icon {
        width: 24px;
        height: 24px;
        cursor: pointer;
      }
      .search-background {
        background-color: var(--mat-sys-surface-container-high);
        border-radius: 128px;
      }
      .action-icon {
        cursor: pointer;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchBarComponent {
  readonly query = model('');
  clearSearch = input.required<() => void>();
  placeholder = input<string>('Search');
  prefixIcon = input<string>('search');
  clearButton = input<boolean>(true);
  backgroundColor = input<boolean>(true);
}
